<template>
  <div :class="prefixCls">
    <Form
      ref="userAddress"
      label-position="left"
      :model="addressData"
      :rules="ruleValidate"
      :label-width="60"
    >
      <FormItem label="所在地区" prop="locationId">
        <z-address v-model="addressData.locationId"></z-address>
      </FormItem>
      <FormItem label="详细地址" prop="detailAddress">
        <Input
          v-model="addressData.detailAddress"
          type="textarea"
          :rows="4"
          :autosize="{minRows: 4,maxRows: 8}"
          placeholder="请输入详细地址"
        ></Input>
      </FormItem>
      <FormItem label="收货人" prop="userName" style="width:350px;margin-top:25px;">
        <Input v-model="addressData.userName" placeholder="请输入收货人姓名"></Input>
      </FormItem>
      <FormItem label="手机号" prop="userMobile" style="width:350px;margin-top:25px;">
        <Input v-model="addressData.userMobile" placeholder="请输入收货人手机号"></Input>
      </FormItem>
      <FormItem>
        <Checkbox :true-value="1" :false-value="0" v-model="addressData.isDefault">设为默认</Checkbox>
      </FormItem>
      <FormItem>
        <Button
          size="large"
          type="primary"
          :loading="loading"
          @click="submitHandle('userAddress')"
        >保存地址</Button>
        <Button size="large" class="cencel-btn" @click="cencelHandle">取消</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
const prefixCls = "zUserads";
import ZAddress from "../address/address";
import Emitter from "../../mixins/emitter.js";
export default {
  name: "ZUserads",
  mixins: [Emitter],
  data() {
    const addressRules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请选择地址"));
      } else {
        callback();
      }
    };
    const addressDetailRules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请输入详细地址"));
      } else {
        callback();
      }
    };
    const usernameRules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请输入收货人姓名"));
      } else {
        callback();
      }
    };
    const userMobileRules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请输入收货人手机号"));
      } else {
        if (!/^1[2345789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      }
    };
    return {
      prefixCls: prefixCls,
      addressData: {
        locationId: "",
        detailAddress: "",
        userName: "",
        userMobile: "",
        isDefault: 0
      },
      ruleValidate: {
        locationId: [{ validator: addressRules, trigger: "change" }],
        detailAddress: [{ validator: addressDetailRules, trigger: "blur" }],
        userName: [{ validator: usernameRules, trigger: "blur" }],
        userMobile: [{ validator: userMobileRules, trigger: "blur" }]
      }
    };
  },
  props: {
    adressPro: {
      type: Object,
      default: function() {
        return {};
      }
    },
    addAddress: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAmend() {
      return this.adressPro && Object.keys(this.adressPro).length > 0
        ? true
        : false;
    }
  },
  components: { ZAddress },
  methods: {
    cencelHandle() {
      if (Object.keys(this.adressPro).length === 0) {
        this.$refs["userAddress"].resetFields();
        this.addressData.isDefault = 0;
      } else {
        this.addressData.detailAddress = this.adressPro.detailAddress;
      }
      this.$emit("cencel");
    },

    // 新增或者修改地址
    submitHandle(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let target = this.isAmend ? "amend" : "add";
          this.$emit("submitAddress", {
            target: target,
            data: this.addressData
          });
        }
      });
    }
  },
  watch: {
    addAddress: function() {
      if (this.addAddress) {
        this.addressData = {
          locationId: "",
          detailAddress: "",
          userName: "",
          userMobile: "",
          isDefault: 0
        };
        this.$refs["userAddress"].resetFields();
      }
    }
  },
  created() {
    if (this.isAmend) {
      this.addressData = this.adressPro;
      this.addressData.detailAddress = this.addressFilter(
        this.addressData.detailAddress
      );
    }
  }
};
</script>

